import api from './api';

/**
 * Service for On-Demand Healthcare payout ledger management.
 */
class OnDemandPayoutService {
  static async getPayouts({ status, hcw, event, limit } = {}) {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (hcw) params.append('hcw', hcw);
    if (event) params.append('event', event);
    if (limit) params.append('limit', limit);

    const query = params.toString();
    return api.get(`/ondemand/payouts${query ? `?${query}` : ''}`);
  }

  static async getBalance() {
    return api.get('/ondemand/payouts/balance');
  }

  static async approvePayout(id) {
    return api.put(`/ondemand/payouts/${id}/approve`);
  }

  static async sendPayout(id) {
    return api.post(`/ondemand/payouts/${id}/send`);
  }
}

export default OnDemandPayoutService;
